<template>
	<div class="bg-login">
		<div class="fondo"></div>
		<div class="contenedor" v-if="fase === 'login'" >
			<div>
				<div class="row">
					<div class="col text-center">
						<img src="/static/recursos/logo_sip.svg" alt="logo" style="height:60px;margin-bottom: 15px;">
					</div>
				</div>
				<div class="card text-left" style="border-radius: 5px;;background-color: rgba(255,255,255,0.4);">
					<!-- <div class="card-header" style="background-color: #a5abb7;">
					</div> -->
					<div class="card-body">
						<div class="row">
							<div class="col">
								<div class="input-group mb-4">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="fa fa-user"></span>
										</span>
									</div>
									<input type="text" class="form-control" placeholder="Usuario" v-model="form.usuario" @keypress.enter="login()" :autocomplete="strNow">
								</div>
							</div>
							<div class="col">
								<div class="input-group mb-4">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="fa fa-lock"></span>
										</span>
									</div>
									<input type="password" class="form-control" placeholder="Password" v-model="form.password" @keypress.enter="login()" :autocomplete="strNow">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<input type="checkbox" v-model="form.recordar" style="vertical-align: middle !important; width: 20px;">
								<span v-if="require2fa">Confiar en este equipo y recordare</span>
								<span v-else>Recordarme durante 15 días</span>
							</div>
							<div class="col text-right">
								<b style="cursor: pointer;" @click="fase = 'restorepass'">Reestablecer contraseña</b>
							</div>
						</div>
					</div>
					<div class="card-body bg-danger text-white" v-if="requiere2fa !== false">
						<h4>Doble factor de autenticación</h4>
						<input type="text" class="form-control text-center" v-model="form.token" placeholder="XXXXXX" @keypress.enter="login()">
					</div>
					<div class="card-body text-center">
						<button class="btn btn-lg btn-block btn-warning" @click="login()">
							<span>
								<i class="fa fa-sign-in mr-2"></i>
							</span>
							Entrar
						</button>
					</div>
				</div>
				<!-- <div class="alert alert-danger text-left mt-2">
					<b style="font-size:1.2em;text-transform: uppercase;">Atención</b>
					<p>
						Este sitio está reservado única y exclusivamente para el <b>personal de Radio Castellón S.A.</b> Si no estás autorizado a entrar, debes
						abandonar inmediatamente esta página.
					</p>
				</div> -->
			</div>
		</div>
		<cambio-pass v-if="fase === 'cambiopass'"></cambio-pass>
		<restore-pass v-if="fase === 'restorepass'" @cerrar="fase = 'login'"></restore-pass>
	</div>
</template>


<script>
import { mapGetters } from 'vuex'
import CambioPass from '../mi-perfil/cambio-pass.vue'
import RestorePassword from './restore'

export default {
	name: 'login',
	components: {
		'cambio-pass': CambioPass,
		'restore-pass': RestorePassword
	},
	data: function () {
		return {
			form: {
				usuario: '',
				password: '',
				token: '',
				recordar: false
			},
			fase: 'login',
			strNow: new Date().getTime().toString()
		}
	},

	created () {
		this.$store.watch(
			a => a.session.cambioPass,
			(nuevo) => {
				console.log(nuevo)
				if (nuevo === true) {
					this.fase = 'cambiopass'
				} else {
					this.fase = 'login'
				}
			}
		)

		this.$store.dispatch('session/getSesion')
	},
	computed: {
		...mapGetters({
			externo: ['session/externo'],
			requiere2fa: ['session/requiere2fa'],
			cambiarPass: ['session/cambiarPass']
		})
	},

	methods: {
		login () {
			this.$store.dispatch('session/login', this.form)
		}
	}
}
</script>


<style scoped>
	.bg-login {
		position: fixed;
		display: block;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: auto;
	}

	.fondo {
		position: fixed;
		display: block;
		top: -10px;
		left: -10px;
		right: -10px;
		bottom: -10px;
		overflow: auto;
		filter: blur(6px);
		background-image: url('./fondo.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.contenedor {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: flex;
		text-align: center;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.contenedor > div {
		position: relative;
		display: block;
		max-width: 500px;
		width: 90%;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/login/login.vue